import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PartnerShopOrder, VetExpertProduct} from "../../models/partner-shop-order.model";
import {PartnerProduct} from "../../models/partner-product.model";

@Component({
  selector: 'app-partner-shop-order-details',
  templateUrl: './partner-shop-order-details.component.html',
  styleUrls: ['./partner-shop-order-details.component.scss'],
})
export class PartnerShopOrderDetailsComponent implements OnInit {

  @Input()
  partnerShopOrder: PartnerShopOrder;

  @Output() objectCancelEmitter = new EventEmitter<boolean>();
  productsOrdered: PartnerProduct[];
  productsBought: PartnerProduct[];


  constructor(
  ) {
  }

  ngOnInit() {
    this.productsOrdered = this.partnerShopOrder.partnerProductsRequestList;
    this.productsBought = this.partnerShopOrder.partnerProductsList;
  }

  onClose() {
    this.objectCancelEmitter.emit(true);
  }
}
